import { SET_CURRENT_TAB } from '../actions/currentTab';

export default function currentTab(state = 'categories', action) {
  switch (action.type) {
    case SET_CURRENT_TAB:
      return action.currentTab;
    default:
      return state;
  }
}
